import React from "react";

export default () => <div className="arrow" data-popper-arrow></div>;
